import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';
import { VALUATION_FRAGMENT } from './valuationFragment';

export const DRAFT_UPDATE_FRAGMENT = gql(
  `
  fragment DraftUpdateFields on NarrativeUpdate @_unmask {
    id
    title
    contentHtml
    coreHtml
    userHoldsPosition
    valuation {
      intrinsicDiscount
      ...ValuationFields
    }
    publishedAt
    willLockAt
  }
`,
  [VALUATION_FRAGMENT]
);

export type DraftUpdate = FragmentOf<typeof DRAFT_UPDATE_FRAGMENT>;
